import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

@observer
class FFEFrontpage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    render() {
        return (<div class='w-100 d-flex justify-content-center position-relative'>
            <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                FFE Frontpage
            </div>
        </div>);
    }
}
export default FFEFrontpage;